import React, { useState } from "react";
import moment from "moment-timezone";
import Datetime from "react-datetime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarAlt,
  faUnlockAlt,
  faEnvelope,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Row,
  Card,
  Form,
  Button,
  InputGroup,
} from "@themesberg/react-bootstrap";
import { FormattedMessage } from "react-intl";
import { authFetch } from "../auth";
import { UpdateSuccess, CreateSuccessModal } from "./Modal";

export const CompanyInfoForm = ({ company, setCompany, handle }) => {
  const [control, setControl] = useState({
    show: false,
    msgId: "",
  });
  const { show, msgId } = control;

  const [msg, setMsg] = useState({
    NameMsg: "",
    NameInRussianMsg: "",
    countryMsg: "",
    RegistrationMsg: "",
    EmailMsg: "",
    AddressMsg: "",
    PrincipalMsg: "",
    PhoneMsg: "",
    WebMsg: "",
    establishMsg: "",
    industryMsg: "",
    workerMsg: "",
    revenueMsg: "",
    contentMsg: "",
    keywordMsg: "",
    industryCodeMsg: "",
  });

  const {
    NameMsg,
    NameInRussianMsg,
    countryMsg,
    RegistrationMsg,
    EmailMsg,
    AddressMsg,
    PrincipalMsg,
    PhoneMsg,
    WebMsg,
    establishMsg,
    industryMsg,
    workerMsg,
    revenueMsg,
    contentMsg,
    keywordMsg,
    industryCodeMsg,
  } = msg;

  const {
    id,
    Name,
    RegistrationID,
    worker_num,
    revenue,
    Phone,
    EmailAddress,
    Website,
    NameInRussian,
    PrincipalName,
    industry,
    establish,
    LegalAddress,
    country,
    content,
    keyword,
    industry_code,
  } = company;

  const [success, setSuccess] = useState(false);
  const [imgFile, setImgFile] = useState(null);	//파일
  var imgBase64 = ""

  const onCompanyChange = (e) => {
    let { name, value } = e.target;

    if (name === "country" && value === "korea") {
      value = 1;
    } else if (name === "country" && value === "russia") {
      value = 2;
    } else if (name === "country" && value === "ozbekiston") {
      value = 3;
    } else if (name === "country" && value === "kyrgyzstan") {
      value = 4;
    } else if (name === "country" && value === "kazakhstan") {
      value = 5;
    } else if (name === "country" && value === "ukraine") {
      value = 6;
    } else if (name === "country" && value === "belarus") {
      value = 7;
    }

    setCompany((prev) => ({ ...prev, [name]: value }));
  };

  const handleChangeFileImg = (event) => {
    setImgFile(event.target.files);
    //fd.append("file", event.target.files)
    for(var i=0;i<event.target.files.length;i++){
      if (event.target.files[i]) {
        let reader = new FileReader();
        reader.readAsDataURL(event.target.files[i]); // 1. 파일을 읽어 버퍼에 저장합니다.
        // 파일 상태 업데이트
        reader.onloadend = () => {
          // 2. 읽기가 완료되면 아래코드가 실행됩니다.
          const base64 = reader.result;
          if (base64) {
            //  images.push(base64.toString())
            var base64Sub = base64.toString();
            imgBase64 = base64Sub;
            var json_req = {"name":RegistrationID,"content":base64Sub};
            
            authFetch(process.env.REACT_APP_API_URL + `/api/uploadImg`, {
                method: "POST",
                body: JSON.stringify({
                  json_req,
                }),
              })
              .then((res) => {
                return res;
              });
          }
        }
      }
    }
  };

  const handleChangeFileVideo = (event) => {
    console.log("handleChangeFileVideo")
    setImgFile(event.target.files);
    //fd.append("file", event.target.files)
    for(var i=0;i<event.target.files.length;i++){
      if (event.target.files[i]) {
        let reader = new FileReader();
        reader.readAsDataURL(event.target.files[i]); // 1. 파일을 읽어 버퍼에 저장합니다.
        // 파일 상태 업데이트
        reader.onloadend = () => {
          // 2. 읽기가 완료되면 아래코드가 실행됩니다.
          const base64 = reader.result;
          if (base64) {
            //  images.push(base64.toString())
            var base64Sub = base64.toString();
            imgBase64 = base64Sub;
            var json_req = {"name":RegistrationID,"content":base64Sub};
            
            authFetch(process.env.REACT_APP_API_URL + `/api/uploadVideo`, {
                method: "POST",
                body: JSON.stringify({
                  json_req,
                }),
              })
              .then((res) => {
                return res;
              });
          }
        }
      }
    }
  };

  const onCompanySubmit = (e) => {
    e.preventDefault();

    authFetch(process.env.REACT_APP_API_URL + `/api/company/${id}`, {
      method: "POST",
      body: JSON.stringify({
        company,
      }),
    })
      .then((res) => {
        setSuccess(true);
        return res.json();
      })
      .then((res) => {
        console.log(res);
      });
  };

  const onCompanyHandle = (e) => {
    e.preventDefault();

    authFetch(process.env.REACT_APP_API_URL + `/api/admin/company/${RegistrationID}`, {
      method: "POST",
      body: JSON.stringify({
        Name,
        RegistrationID,
        worker_num,
        revenue,
        Phone,
        EmailAddress,
        Website,
        NameInRussian,
        PrincipalName,
        industry,
        establish,
        LegalAddress,
        country,
        content,
        industry_code,
      }),
    }).then((resp) => {
      if (resp.status === 200) {
        setControl({
          show: true,
          msgId: "success",
        });
      } else {
        setControl({
          show: true,
          msgId: "fail",
        });
      }
    });
  };

  return (
    <Form>
      <Form.Group id="companyName" className="mb-4">
        <Form.Label>
          <FormattedMessage id="companyNm" />
        </Form.Label>
        <InputGroup>
          <Form.Control
            required
            type="text"
            placeholder="Example"
            name="Name"
            value={Name}
            onChange={onCompanyChange}
          />
        </InputGroup>
        {NameMsg && <div className="text-danger">{NameMsg}</div>}
      </Form.Group>

      <Form.Group id="companyNameInRussian" className="mb-4">
        <Form.Label>
          <FormattedMessage id="companyNmRussian" />
        </Form.Label>
        <InputGroup>
          <Form.Control
            required
            type="text"
            placeholder="Example"
            name="NameInRussian"
            value={NameInRussian}
            onChange={onCompanyChange}
          />
        </InputGroup>
        {NameInRussianMsg && (
          <div className="text-danger">{NameInRussianMsg}</div>
        )}
      </Form.Group>

      <Form.Group id="country" className="mb-4">
        <Form.Label>
          <FormattedMessage id="country" />
        </Form.Label>
        <InputGroup>
          <InputGroup.Radio
            name="country"
            value="korea"
            checked={country === 1}
            onChange={onCompanyChange}
          />
          <InputGroup.Text>
            <FormattedMessage id="Korea" />
          </InputGroup.Text>
          <InputGroup.Radio
            name="country"
            value="russia"
            checked={country === 2}
            onChange={onCompanyChange}
          />
          <InputGroup.Text>
            <FormattedMessage id="Russia" />
          </InputGroup.Text>
          <InputGroup.Radio
            name="country"
            value="ozbekiston"
            checked={country === 3}
            onChange={onCompanyChange}
          />
          <InputGroup.Text>
            <FormattedMessage id="Ozbekiston" />
          </InputGroup.Text>
          <InputGroup.Radio
            name="country"
            value="kyrgyzstan"
            checked={country === 4}
            onChange={onCompanyChange}
          />
          <InputGroup.Text>
            <FormattedMessage id="Kyrgyzstan" />
          </InputGroup.Text>
          <InputGroup.Radio
            name="country"
            value="kazakhstan"
            checked={country === 5}
            onChange={onCompanyChange}
          />
          <InputGroup.Text>
            <FormattedMessage id="Kazakhstan" />
          </InputGroup.Text>
          <InputGroup.Radio
            name="country"
            value="ukraine"
            checked={country === 6}
            onChange={onCompanyChange}
          />
          <InputGroup.Text>
            <FormattedMessage id="Ukraine" />
          </InputGroup.Text>
          <InputGroup.Radio
            name="country"
            value="belarus"
            checked={country === 7}
            onChange={onCompanyChange}
          />
          <InputGroup.Text>
            <FormattedMessage id="Belarus" />
          </InputGroup.Text>
        </InputGroup>
        {countryMsg && <div className="text-danger">{countryMsg}</div>}
      </Form.Group>

      <Form.Group id="RegistrationID" className="mb-4">
        <Form.Label>
          <FormattedMessage id="registration" />
        </Form.Label>
        <InputGroup>
          <Form.Control
            required
            type="number"
            placeholder="00000000"
            name="RegistrationID"
            value={RegistrationID}
            onChange={onCompanyChange}
          />
        </InputGroup>
        {RegistrationMsg && (
          <div className="text-danger">{RegistrationMsg}</div>
        )}
      </Form.Group>
      <Form.Group id="EmailAddress" className="mb-4">
        <Form.Label>
          <FormattedMessage id="email" />
        </Form.Label>
        <InputGroup>
          <Form.Control
            required
            type="text"
            placeholder="Example"
            name="EmailAddress"
            value={EmailAddress}
            onChange={onCompanyChange}
          />
        </InputGroup>
        {EmailMsg && <div className="text-danger">{EmailMsg}</div>}
      </Form.Group>
      <Form.Group id="LegalAddress" className="mb-4">
        <Form.Label>
          <FormattedMessage id="address" />
        </Form.Label>
        <InputGroup>
          <Form.Control
            required
            type="text"
            placeholder="Example"
            name="LegalAddress"
            value={LegalAddress}
            onChange={onCompanyChange}
          />
        </InputGroup>
        {AddressMsg && <div className="text-danger">{AddressMsg}</div>}
      </Form.Group>

      <Form.Group id="PrincipalName" className="mb-4">
        <Form.Label>
          <FormattedMessage id="principal" />
        </Form.Label>
        <InputGroup>
          <Form.Control
            required
            type="text"
            placeholder="Example"
            name="PrincipalName"
            value={PrincipalName}
            onChange={onCompanyChange}
          />
        </InputGroup>
        {PrincipalMsg && <div className="text-danger">{PrincipalMsg}</div>}
      </Form.Group>

      <Form.Group id="PhoneNumber" className="mb-4">
        <Form.Label>
          <FormattedMessage id="phone" />
        </Form.Label>
        <InputGroup>
          <Form.Control
            required
            type="phone"
            placeholder="+7 (000) 0000000"
            name="Phone"
            value={Phone}
            onChange={onCompanyChange}
          />
        </InputGroup>
        {PhoneMsg && <div className="text-danger">{PhoneMsg}</div>}
      </Form.Group>

      <Form.Group id="Website" className="mb-4">
        <Form.Label>
          <FormattedMessage id="website" />
        </Form.Label>
        <InputGroup>
          <Form.Control
            required
            type="text"
            placeholder="www.example.com"
            name="Website"
            value={Website}
            onChange={onCompanyChange}
          />
        </InputGroup>
        {WebMsg && <div className="text-danger">{WebMsg}</div>}
      </Form.Group>

      <Form.Group id="RegistrationDate" className="mb-4">
        <Form.Label>
          <FormattedMessage id="registrationDate" />
        </Form.Label>
        <InputGroup>
          <Form.Control
            required
            type="text"
            placeholder="yyyy-mm-dd"
            name="establish"
            value={establish}
            onChange={onCompanyChange}
          />
        </InputGroup>
        {establishMsg && <div className="text-danger">{establishMsg}</div>}
      </Form.Group>

      <Form.Group id="BusinessName" className="mb-4">
        <Form.Label>
          <FormattedMessage id="business" />
        </Form.Label>
        <InputGroup>
          <Form.Control
            required
            type="text"
            placeholder="Example"
            name="industry"
            value={industry}
            onChange={onCompanyChange}
          />
        </InputGroup>
        {industryMsg && <div className="text-danger">{industryMsg}</div>}
      </Form.Group>
      <Form.Group id="BusinessCode" className="mb-4">
        <Form.Label>
          산업 코드
        </Form.Label>
        <InputGroup>
          <Form.Control
            required
            type="text"
            placeholder="00000"
            name="industry_code"
            value={industry_code}
            onChange={onCompanyChange}
          />
        </InputGroup>
        {industryCodeMsg && <div className="text-danger">{industryCodeMsg}</div>}
      </Form.Group>

      <Form.Group id="workerNumber" className="mb-4">
        <Form.Label>
          <FormattedMessage id="worker" />
        </Form.Label>
        <InputGroup>
          <Form.Control
            required
            type="number"
            placeholder="0"
            name="worker_num"
            value={worker_num}
            onChange={onCompanyChange}
          />
        </InputGroup>
        {workerMsg && <div className="text-danger">{workerMsg}</div>}
      </Form.Group>

      <Form.Group id="revenueNumber" className="mb-4">
        <Form.Label>
          <FormattedMessage id="revenue" /> (RUB)
        </Form.Label>
        <InputGroup>
          <Form.Control
            required
            type="number"
            placeholder="1000"
            name="revenue"
            value={revenue}
            onChange={onCompanyChange}
          />
        </InputGroup>
        {revenueMsg && <div className="text-danger">{revenueMsg}</div>}
      </Form.Group>
      <Form.Group id="Content" className="mb-4">
        <Form.Label>
          소개문
        </Form.Label>
        <InputGroup>
          <Form.Control
            required
            type="text"
            placeholder="Example"
            name="content"
            value={content}
            onChange={onCompanyChange}
          />
        </InputGroup>
        {contentMsg && <div className="text-danger">{contentMsg}</div>}
      </Form.Group>
      <Form.Group id="keyword" className="mb-4">
        <Form.Label>
          키워드
        </Form.Label>
        <InputGroup>
          <Form.Control
            required
            type="text"
            placeholder="Example"
            name="keyword"
            value={keyword}
            onChange={onCompanyChange}
          />
        </InputGroup>
        {keywordMsg && <div className="text-danger">{keywordMsg}</div>}
      </Form.Group>
      <Form.Group id="ProfileImage" className="mb-4">
        <Form.Label>
          프로필 이미지
        </Form.Label>
        <InputGroup>
          <Form.Control
            required
            type="file"
            name="profile_img"
            onChange={handleChangeFileImg}
          />
        </InputGroup>
      </Form.Group>
      <div className="mt-4">
        <Button
          variant="primary"
          type="submit"
          className="w-100"
          onClick={handle ? onCompanyHandle : onCompanySubmit}
        >
          <FormattedMessage id="toEdit" />
        </Button>
        {success && <UpdateSuccess />}
        {show && <CreateSuccessModal id={msgId} />}
      </div>
    </Form>
  );
};

export const UserCompanyInfoForm = ({ company, setCompany, HandleSubmit }) => {
  const [msg, setMsg] = useState({
    NameInRussianMsg: "",
    countryMsg: "",
    EmailMsg: "",
    AddressMsg: "",
    PrincipalMsg: "",
    PhoneMsg: "",
    WebMsg: "",
    establishMsg: "",
    industryMsg: "",
    workerMsg: "",
    revenueMsg: "",
    contentMsg: "",
    keywordMsg: "",
    industryCodeMsg: "",
  });

  const {
    NameInRussianMsg,
    countryMsg,
    EmailMsg,
    AddressMsg,
    PrincipalMsg,
    PhoneMsg,
    WebMsg,
    establishMsg,
    industryMsg,
    workerMsg,
    revenueMsg,
    contentMsg,
    keywordMsg,
    industryCodeMsg,
  } = msg;

  const {
    id,
    worker_num,
    revenue,
    Phone,
    EmailAddress,
    Website,
    NameInRussian,
    PrincipalName,
    industry,
    establish,
    LegalAddress,
    country,
    content,
    keyword,
    industry_code,
  } = company;

  const [success, setSuccess] = useState(false);

  const onCompanyChange = (e) => {
    let { name, value } = e.target;

    if (name === "country" && value === "korea") {
      value = 1;
    } else if (name === "country" && value === "russia") {
      value = 2;
    }

    setCompany((prev) => ({ ...prev, [name]: value }));
  };

  const onCompanySubmit = (e) => {
    e.preventDefault();

    authFetch(process.env.REACT_APP_API_URL + `/api/company/${id}`, {
      method: "POST",
      body: JSON.stringify({
        company,
      }),
    })
      .then((res) => {
        setSuccess(true);
        return res.json();
      })
      .then((res) => {
        console.log(res);
      });
  };

  return (
    <Form>
      <Form.Group id="companyNameInRussian" className="mb-4">
        <Form.Label>
          <FormattedMessage id="companyNmRussian" />
        </Form.Label>
        <InputGroup>
          <Form.Control
            required
            type="text"
            placeholder="Example"
            name="NameInRussian"
            value={NameInRussian}
            onChange={onCompanyChange}
          />
        </InputGroup>
        {NameInRussianMsg && (
          <div className="text-danger">{NameInRussianMsg}</div>
        )}
      </Form.Group>

      <Form.Group id="country" className="mb-4">
        <Form.Label>
          <FormattedMessage id="country" />
        </Form.Label>
        <InputGroup>
          <InputGroup.Radio
            name="country"
            value="korea"
            checked={country === 1}
            onChange={onCompanyChange}
          />
          <InputGroup.Text>
            <FormattedMessage id="Korea" />
          </InputGroup.Text>
          <InputGroup.Radio
            name="country"
            value="russia"
            checked={country === 2}
            onChange={onCompanyChange}
          />
          <InputGroup.Text>
            <FormattedMessage id="Russia" />
          </InputGroup.Text>
        </InputGroup>
        {countryMsg && <div className="text-danger">{countryMsg}</div>}
      </Form.Group>
      <Form.Group id="EmailAddress" className="mb-4">
        <Form.Label>
          <FormattedMessage id="email" />
        </Form.Label>
        <InputGroup>
          <Form.Control
            required
            type="text"
            placeholder="Example"
            name="EmailAddress"
            value={EmailAddress}
            onChange={onCompanyChange}
          />
        </InputGroup>
        {EmailMsg && <div className="text-danger">{EmailMsg}</div>}
      </Form.Group>
      <Form.Group id="LegalAddress" className="mb-4">
        <Form.Label>
          <FormattedMessage id="address" />
        </Form.Label>
        <InputGroup>
          <Form.Control
            required
            type="text"
            placeholder="Example"
            name="LegalAddress"
            value={LegalAddress}
            onChange={onCompanyChange}
          />
        </InputGroup>
        {AddressMsg && <div className="text-danger">{AddressMsg}</div>}
      </Form.Group>

      <Form.Group id="PrincipalName" className="mb-4">
        <Form.Label>
          <FormattedMessage id="principal" />
        </Form.Label>
        <InputGroup>
          <Form.Control
            required
            type="text"
            placeholder="Example"
            name="PrincipalName"
            value={PrincipalName}
            onChange={onCompanyChange}
          />
        </InputGroup>
        {PrincipalMsg && <div className="text-danger">{PrincipalMsg}</div>}
      </Form.Group>

      <Form.Group id="PhoneNumber" className="mb-4">
        <Form.Label>
          <FormattedMessage id="phone" />
        </Form.Label>
        <InputGroup>
          <Form.Control
            required
            type="phone"
            placeholder="+7 (000) 0000000"
            name="Phone"
            value={Phone}
            onChange={onCompanyChange}
          />
        </InputGroup>
        {PhoneMsg && <div className="text-danger">{PhoneMsg}</div>}
      </Form.Group>

      <Form.Group id="Website" className="mb-4">
        <Form.Label>
          <FormattedMessage id="website" />
        </Form.Label>
        <InputGroup>
          <Form.Control
            required
            type="text"
            placeholder="www.example.com"
            name="Website"
            value={Website}
            onChange={onCompanyChange}
          />
        </InputGroup>
        {WebMsg && <div className="text-danger">{WebMsg}</div>}
      </Form.Group>

      <Form.Group id="RegistrationDate" className="mb-4">
        <Form.Label>
          <FormattedMessage id="registrationDate" />
        </Form.Label>
        <InputGroup>
          <Form.Control
            required
            type="text"
            placeholder="yyyy-mm-dd"
            name="establish"
            value={establish}
            onChange={onCompanyChange}
          />
        </InputGroup>
        {establishMsg && <div className="text-danger">{establishMsg}</div>}
      </Form.Group>

      <Form.Group id="BusinessName" className="mb-4">
        <Form.Label>
          <FormattedMessage id="business" />
        </Form.Label>
        <InputGroup>
          <Form.Control
            required
            type="text"
            placeholder="Example"
            name="industry"
            value={industry}
            onChange={onCompanyChange}
          />
        </InputGroup>
        {industryMsg && <div className="text-danger">{industryMsg}</div>}
      </Form.Group>
      <Form.Group id="BusinessCode" className="mb-4">
        <Form.Label>
          산업 코드
        </Form.Label>
        <InputGroup>
          <Form.Control
            required
            type="text"
            placeholder="Example"
            name="industry_code"
            value={industry_code}
            onChange={onCompanyChange}
          />
        </InputGroup>
        {industryCodeMsg && <div className="text-danger">{industryCodeMsg}</div>}
      </Form.Group>
      <Form.Group id="workerNumber" className="mb-4">
        <Form.Label>
          <FormattedMessage id="worker" />
        </Form.Label>
        <InputGroup>
          <Form.Control
            required
            type="number"
            placeholder="0"
            name="worker_num"
            value={worker_num}
            onChange={onCompanyChange}
          />
        </InputGroup>
        {workerMsg && <div className="text-danger">{workerMsg}</div>}
      </Form.Group>

      <Form.Group id="revenueNumber" className="mb-4">
        <Form.Label>
          <FormattedMessage id="revenue" /> (RUB)
        </Form.Label>
        <InputGroup>
          <Form.Control
            required
            type="number"
            placeholder="1000"
            name="revenue"
            value={revenue}
            onChange={onCompanyChange}
          />
        </InputGroup>
        {revenueMsg && <div className="text-danger">{revenueMsg}</div>}
      </Form.Group>
      <Form.Group id="Content" className="mb-4">
        <Form.Label>
          소개문
        </Form.Label>
        <InputGroup>
          <Form.Control
            required
            type="text"
            placeholder="Example"
            name="content"
            value={content}
            onChange={onCompanyChange}
          />
        </InputGroup>
        {contentMsg && <div className="text-danger">{contentMsg}</div>}
      </Form.Group>
      <Form.Group id="Keyword" className="mb-4">
        <Form.Label>
          소개문
        </Form.Label>
        <InputGroup>
          <Form.Control
            required
            type="text"
            placeholder="Example"
            name="keyword"
            value={keyword}
            onChange={onCompanyChange}
          />
        </InputGroup>
        {keywordMsg && <div className="text-danger">{keywordMsg}</div>}
      </Form.Group>
      <div className="mt-4">
        <Button
          variant="primary"
          type="submit"
          className="w-100"
          onClick={HandleSubmit || onCompanySubmit}
        >
          <FormattedMessage id="toEdit" />
        </Button>
        {success && <UpdateSuccess />}
      </div>
    </Form>
  );
};

export const UserEditForm = ({ user }) => {
  const [input, setInput] = useState({ ...user });
  const { id, username, email, registration, companyName } = input;
  const [msg, setMsg] = useState("");

  const onChange = (evt) => {
    const { name, value } = evt.target;
    setInput((prev) => ({ ...prev, [name]: value }));
  };

  const onUserUpdate = (evt) => {
    evt.preventDefault();

    authFetch(process.env.REACT_APP_API_URL + `/api/admin/user/${id}`, {
      method: "POST",
      body: JSON.stringify({ ...input }),
    })
      .then((resp) => {
        if (resp.status === 200) {
          window.location.reload();
        }
        return resp.json();
      })
      .then((resp) => {
        setMsg(resp.msg);
      });
  };

  return (
    <Form>
      <div className="mt-4">
        <h5>
          <FormattedMessage id="id" />
        </h5>
        <p className="mb-4">{username}</p>
        <h5>
          <FormattedMessage id="registedEmail" />
        </h5>
        <p className="mb-4">{email}</p>
        <Form.Group id="companyNm" className="mb-4">
          <Form.Label>
            <FormattedMessage id="companyNm" />
          </Form.Label>
          <InputGroup>
            <Form.Control
              required
              type="text"
              placeholder="Example"
              name="companyName"
              value={companyName}
              onChange={onChange}
            />
          </InputGroup>
        </Form.Group>
        <Form.Group id="registration" className="mb-4">
          <Form.Label>
            <FormattedMessage id="registration" />
          </Form.Label>
          <InputGroup>
            <Form.Control
              required
              type="number"
              placeholder="00000000"
              name="registration"
              value={registration}
              onChange={onChange}
            />
          </InputGroup>
        </Form.Group>
        {msg && <div className="text-danger">{msg}</div>}
        <Button
          variant="primary"
          type="submit"
          className="w-100"
          onClick={onUserUpdate}
        >
          <FormattedMessage id="toEdit" />
        </Button>
      </div>
    </Form>
  );
};

export const CreateUserForm = () => {
  const [input, setInput] = useState({
    id: "",
    email: "",
    pwd: "",
    pwdConfirm: "",
    registration: 0,
    companyName: "",
  });
  const { id, email, pwd, pwdConfirm, registration, companyName } = input;

  const [msg, setMsg] = useState("");

  const onChange = (evt) => {
    const { name, value } = evt.target;
    setInput((prev) => ({ ...prev, [name]: value }));
  };

  const onSubmit = (evt) => {
    evt.preventDefault();

    if (!id) {
      setMsg("아이디를 입력해주세요");
      return;
    }

    if (!email) {
      setMsg("이메일을 입력해주세요");
      return;
    }

    if (!pwd) {
      setMsg("비밀번호를 입력해주세요");
      return;
    }

    if (pwd !== pwdConfirm) {
      setMsg("비밀번호가 일치하지 않습니다.");
      return;
    }

    if (!companyName) {
      setMsg("회사명을 입력해주세요");
      return;
    }

    if (registration === 0) {
      setMsg("사업자 등록번호를 입력해주세요");
    }

    authFetch(process.env.REACT_APP_API_URL + "/api/admin/user", {
      method: "POST",
      body: JSON.stringify({
        ...input,
      }),
    })
      .then((resp) => {
        if (resp.status === 200) {
          window.location.reload();
        }
        return resp.json();
      })
      .then((resp) => {
        setMsg(resp.msg);
      });
  };

  return (
    <Form className="mt-4">
      <Form.Group id="id" className="mb-4">
        <Form.Label>
          <FormattedMessage id="id" />
        </Form.Label>
        <InputGroup>
          <InputGroup.Text>
            <FontAwesomeIcon icon={faUser} />
          </InputGroup.Text>
          <Form.Control
            autoFocus
            required
            type="text"
            placeholder="example"
            name="id"
            value={id}
            onChange={onChange}
          />
        </InputGroup>
      </Form.Group>
      <Form.Group id="email" className="mb-4">
        <Form.Label>
          <FormattedMessage id="email" />
        </Form.Label>
        <InputGroup>
          <InputGroup.Text>
            <FontAwesomeIcon icon={faEnvelope} />
          </InputGroup.Text>
          <Form.Control
            autoFocus
            required
            type="email"
            placeholder="example@company.com"
            name="email"
            value={email}
            onChange={onChange}
          />
        </InputGroup>
      </Form.Group>
      <Form.Group id="password" className="mb-4">
        <Form.Label>
          <FormattedMessage id="password" />
        </Form.Label>
        <InputGroup>
          <InputGroup.Text>
            <FontAwesomeIcon icon={faUnlockAlt} />
          </InputGroup.Text>
          <Form.Control
            required
            type="password"
            placeholder="Password"
            name="pwd"
            value={pwd}
            onChange={onChange}
          />
        </InputGroup>
      </Form.Group>
      <Form.Group id="confirmPassword" className="mb-4">
        <Form.Label>
          <FormattedMessage id="passwordConfirm" />
        </Form.Label>
        <InputGroup>
          <InputGroup.Text>
            <FontAwesomeIcon icon={faUnlockAlt} />
          </InputGroup.Text>
          <Form.Control
            required
            type="password"
            placeholder="Confirm Password"
            name="pwdConfirm"
            value={pwdConfirm}
            onChange={onChange}
          />
        </InputGroup>
      </Form.Group>
      <Form.Group id="companyNm" className="mb-4">
        <Form.Label>
          <FormattedMessage id="companyNm" />
        </Form.Label>
        <InputGroup>
          <Form.Control
            required
            type="test"
            placeholder="Example"
            name="companyName"
            value={companyName}
            onChange={onChange}
          />
        </InputGroup>
      </Form.Group>
      <Form.Group id="registration" className="mb-4">
        <Form.Label>
          <FormattedMessage id="registration" />
        </Form.Label>
        <InputGroup>
          <Form.Control
            required
            type="number"
            placeholder="00000000"
            name="registration"
            value={registration}
            onChange={onChange}
          />
        </InputGroup>
      </Form.Group>
      {msg && <p className="text-danger">{msg}</p>}
      <Button
        variant="primary"
        type="submit"
        className="w-100"
        onClick={onSubmit}
      >
        <FormattedMessage id="confirm" />
      </Button>
    </Form>
  );
};

export const GeneralInfoForm = () => {
  const [birthday, setBirthday] = useState("");

  return (
    <Card border="light" className="bg-white shadow-sm mb-4">
      <Card.Body>
        <h5 className="mb-4">General information</h5>
        <Form>
          <Row>
            <Col md={6} className="mb-3">
              <Form.Group id="firstName">
                <Form.Label>First Name</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="Enter your first name"
                />
              </Form.Group>
            </Col>
            <Col md={6} className="mb-3">
              <Form.Group id="lastName">
                <Form.Label>Last Name</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="Also your last name"
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className="align-items-center">
            <Col md={6} className="mb-3">
              <Form.Group id="birthday">
                <Form.Label>Birthday</Form.Label>
                <Datetime
                  timeFormat={false}
                  onChange={setBirthday}
                  renderInput={(props, openCalendar) => (
                    <InputGroup>
                      <InputGroup.Text>
                        <FontAwesomeIcon icon={faCalendarAlt} />
                      </InputGroup.Text>
                      <Form.Control
                        required
                        type="text"
                        value={
                          birthday ? moment(birthday).format("MM/DD/YYYY") : ""
                        }
                        placeholder="mm/dd/yyyy"
                        onFocus={openCalendar}
                        onChange={() => {}}
                      />
                    </InputGroup>
                  )}
                />
              </Form.Group>
            </Col>
            <Col md={6} className="mb-3">
              <Form.Group id="gender">
                <Form.Label>Gender</Form.Label>
                <Form.Select defaultValue="0">
                  <option value="0">Gender</option>
                  <option value="1">Female</option>
                  <option value="2">Male</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6} className="mb-3">
              <Form.Group id="emal">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  required
                  type="email"
                  placeholder="name@company.com"
                />
              </Form.Group>
            </Col>
            <Col md={6} className="mb-3">
              <Form.Group id="phone">
                <Form.Label>Phone</Form.Label>
                <Form.Control
                  required
                  type="number"
                  placeholder="+12-345 678 910"
                />
              </Form.Group>
            </Col>
          </Row>

          <h5 className="my-4">Address</h5>
          <Row>
            <Col sm={9} className="mb-3">
              <Form.Group id="address">
                <Form.Label>Address</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="Enter your home address"
                />
              </Form.Group>
            </Col>
            <Col sm={3} className="mb-3">
              <Form.Group id="addressNumber">
                <Form.Label>Number</Form.Label>
                <Form.Control required type="number" placeholder="No." />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={4} className="mb-3">
              <Form.Group id="city">
                <Form.Label>City</Form.Label>
                <Form.Control required type="text" placeholder="City" />
              </Form.Group>
            </Col>
            <Col sm={4} className="mb-3">
              <Form.Group className="mb-2">
                <Form.Label>Select state</Form.Label>
                <Form.Select id="state" defaultValue="0">
                  <option value="0">State</option>
                  <option value="AL">Alabama</option>
                  <option value="AK">Alaska</option>
                  <option value="AZ">Arizona</option>
                  <option value="AR">Arkansas</option>
                  <option value="CA">California</option>
                  <option value="CO">Colorado</option>
                  <option value="CT">Connecticut</option>
                  <option value="DE">Delaware</option>
                  <option value="DC">District Of Columbia</option>
                  <option value="FL">Florida</option>
                  <option value="GA">Georgia</option>
                  <option value="HI">Hawaii</option>
                  <option value="ID">Idaho</option>
                  <option value="IL">Illinois</option>
                  <option value="IN">Indiana</option>
                  <option value="IA">Iowa</option>
                  <option value="KS">Kansas</option>
                  <option value="KY">Kentucky</option>
                  <option value="LA">Louisiana</option>
                  <option value="ME">Maine</option>
                  <option value="MD">Maryland</option>
                  <option value="MA">Massachusetts</option>
                  <option value="MI">Michigan</option>
                  <option value="MN">Minnesota</option>
                  <option value="MS">Mississippi</option>
                  <option value="MO">Missouri</option>
                  <option value="MT">Montana</option>
                  <option value="NE">Nebraska</option>
                  <option value="NV">Nevada</option>
                  <option value="NH">New Hampshire</option>
                  <option value="NJ">New Jersey</option>
                  <option value="NM">New Mexico</option>
                  <option value="NY">New York</option>
                  <option value="NC">North Carolina</option>
                  <option value="ND">North Dakota</option>
                  <option value="OH">Ohio</option>
                  <option value="OK">Oklahoma</option>
                  <option value="OR">Oregon</option>
                  <option value="PA">Pennsylvania</option>
                  <option value="RI">Rhode Island</option>
                  <option value="SC">South Carolina</option>
                  <option value="SD">South Dakota</option>
                  <option value="TN">Tennessee</option>
                  <option value="TX">Texas</option>
                  <option value="UT">Utah</option>
                  <option value="VT">Vermont</option>
                  <option value="VA">Virginia</option>
                  <option value="WA">Washington</option>
                  <option value="WV">West Virginia</option>
                  <option value="WI">Wisconsin</option>
                  <option value="WY">Wyoming</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col sm={4}>
              <Form.Group id="zip">
                <Form.Label>ZIP</Form.Label>
                <Form.Control required type="tel" placeholder="ZIP" />
              </Form.Group>
            </Col>
          </Row>
          <div className="mt-3">
            <Button variant="primary" type="submit">
              Save All
            </Button>
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
};
